export type Testimony = {
  slug: string
  name: string
  title: string
  excerpt: string
  paragraphs: string[]
}

export const testimonies: Testimony[] = [
  {
    slug: 'catherine-akerele-restoration',
    name: 'Catherine Akerele',
    title: 'Restoration and Breakthroughs',
    excerpt:
      'I have come to return all glory to our marvelous God for the wonderful things He has done in my life and my family as a whole.',
    paragraphs: [
      'I have come to return all glory to our marvelous God for the wonderful things He has done in my life and my family as a whole.',
      "Through the prayers and by the leading of prophecy through God's servant, my very, very, very turbulent marriage was restored miraculously. My home is now a home of God; He saved me from death and restored my health.",
      'My daughter got a prestigious job while in her 200 level during her undergraduate days in the higher institution, and she is doing exploits.',
      "My land that was seized for not being able to pay back the loan I obtained to pay my children's fees was miraculously restored back to me.",
      'My second son, who is a gospel minister, launched his songs.',
      'My eldest son got a prestigious job in an oil and gas firm miraculously without applying for the job, through someone I have never met in my life.',
      'I have lots and lots of testimonies, but I am restrained. God is a wonderful God.',
    ],
  },
  {
    slug: 'blessings-through-camp-david-nation',
    name: 'Royalty Osedebamen',
    title: 'Blessings Through Camp David Nation',
    excerpt:
      "Camp David Nation (CDN) is indeed God's vision. CDN has been a blessing to me and my children, who are now members. God speaks here and fulfills His word.",
    paragraphs: [
      "Praise God! Camp David Nation (CDN) is indeed God's vision. I want to say that CDN has been a blessing to me and my children, who are now members. God speaks here and fulfills His word.",
      'Since I joined this vision, I have had no regrets whatsoever, and I always look forward to our various meetings.',
      'God has come through for me many times via this platform during both good and bad times. There were times when all I could say was, "God help me," and in our next meeting, the word of God would come expressly.',
      'Finally, I am going nowhere because CDN is one of my sure connections.',
    ],
  },
  {
    slug: 'transformation-through-cdpp',
    name: 'Divine Favour Areghan',
    title: 'Transformation Through Camp David Prayer Platform',
    excerpt:
      'For three long years, I faced the heartbreak of waiting for admission into my desired program. Then I discovered the Camp David Prayer Platform — and everything changed.',
    paragraphs: [
      'I want to share my incredible journey of faith and how joining the Camp David Prayer Platform has truly changed my life. For three long years, I faced the heartbreak of waiting for admission into my desired program. The process was filled with uncertainty, anxiety, and moments of doubt. It felt like my dreams were slipping away.',
      'In the midst of my struggles, I discovered the Camp David Prayer Platform. Initially, I joined out of desperation, hoping for a miracle. The warm community and powerful prayers ignited a flicker of hope within me. I started participating actively, pouring out my heart every session, sharing my burdens, and connecting with others who were also seeking divine intervention.',
      "Through the unwavering support of the prayer group, I learned to trust God's timing and plan for my life. Every prayer I offered transformed from a cry of desperation to a declaration of faith. I began to see God's hand in my life, each prayer session further solidifying my belief.",
      "Finally, after three years of waiting, the long-awaited news came: I had been accepted into my desired program! The joy and relief that washed over me were overwhelming. I couldn't contain my praises to God\u2014He had answered my prayers when I least expected it.",
      'Joining the Camp David Prayer Platform was more than just a change of circumstances; it was a profound spiritual awakening. I learned that patience, prayer, and persistence can lead to glorious outcomes. My faith deepened, and every trial became a stepping stone toward a greater purpose.',
      'To anyone waiting for their prayers to be answered: hold on, keep praying, and trust in His perfect timing. Your story can end in praise too!',
    ],
  },
]

export const getTestimonyBySlug = (slug: string) =>
  testimonies.find((t) => t.slug === slug)
